import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import styled, { css } from "styled-components";
import { Col, Row } from "react-bootstrap";
import { ArrowsMove } from "react-bootstrap-icons";

const RowServices = styled(Row)`
  height: 50px;
  align-items: center;
`;

const ColServices = styled(Col)`
  border: 1px solid #d4d4d4;
  padding: 0.5rem;
  height: 100%;
  display: flex;
  align-items: center;

  ${(props) =>
    !props.header &&
    css`
      border-top: none;
    `}

  ${(props) =>
    props.header &&
    css`
      font-weight: 700;
      justify-content: center;
    `}
  
  ${(props) =>
    props.idx === 0 &&
    css`
      border-right: none;
      justify-content: ${!props.header ? "flex-start" : "center"};
      text-align: ${!props.header ? "left" : "center"};
    `}

    ${(props) =>
    props.idx === 1 &&
    css`
      justify-content: ${!props.header ? "flex-end" : "center"};
    `}
  
  ${(props) =>
    props.idx === 2 &&
    css`
      border-left: none;
      justify-content: center;
    `}
  ${(props) =>
    props.idx === 3 &&
    css`
      border: none;
      justify-content: center;
    `}
    ${(props) =>
    props.idx === 4 &&
    css`
      border-left: none;
      border-right: none;
      justify-content: ${!props.header ? "flex-start" : "center"};
    `}
`;

export const DraggableService = ({ jobService, index, moveService }) => {
  const [{ isDragging }, dragRef] = useDrag({
    type: "item",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [spec, dropRef] = useDrop({
    accept: "item",
    hover: (item, monitor) => {
      const dragIndex = item.index;
      const hoverIndex = index;
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const hoverActualY = monitor.getClientOffset().y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverActualY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverActualY > hoverMiddleY) return;

      moveService(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const ref = useRef(null);
  const dragDropRef = dragRef(dropRef(ref));

  const opacity = isDragging ? 0 : 1;
  return (
    <div ref={dragDropRef} style={{ opacity }}>
      <RowServices>
        <ColServices xs={3} lg={4} idx={0}>
          <ArrowsMove
            style={{ color: "black", fontSize: "15px", marginRight: "5px" }}
          />
          {jobService.name}
        </ColServices>
        <ColServices xs={2} lg={3} idx={1}>
          {jobService.price}
        </ColServices>
        <ColServices xs={3} lg={3} idx={2}>
          {jobService?.sku}
        </ColServices>
      </RowServices>
    </div>
  );
};
